<div class="pv2-adicional-editor"
     [class.is-standalone]="standalone"
     [class.is-creation-config]="creationPhase === 'config'"
     [class.is-full-phase]="creationPhase === 'full'"
     [class.is-choice-mode]="isChoiceMode"
     [class.is-library-mode]="isLibraryMode"
     [class.is-create-mode]="isCreateMode"
     [class.is-embedded-context]="isEmbeddedContext"
     *ngIf="groupDraft">
  <div class="pv2-adicional-editor__content">

  <header class="pv2-adicional-hero" *ngIf="!isChoiceMode && !isLibraryMode && !standalone">
    <button type="button" class="pv2-adicional-hero__back" (click)="goBack()">
      <span class="fa fa-chevron-left"></span>
    </button>
    <div>
      <h2>{{ mode === 'create' ? 'Criar adicional' : (groupDraft?.name || 'Editar adicional') }}</h2>
      <span class="pv2-adicional-hero__status">
        <span class="pv2-adicional-hero__dot"></span>
        {{ heroStatusLabel }}
      </span>
    </div>
  </header>

  <div class="pv2-adicional-header__lead" *ngIf="isChoiceMode">
    <h3>Como deseja adicionar?</h3>
    <p>Escolha como criar seu novo adicional.</p>
  </div>

  <section class="pv2-choice-shell" *ngIf="isChoiceMode">
    <div class="pv2-choice-grid" *ngIf="!choiceProbing; else choiceProbingTpl">
      <button type="button" class="pv2-choice-card" (click)="selectChoice('create')">
        <div class="pv2-choice-card__icon is-create">
          <span class="fa fa-plus"></span>
        </div>
        <h4>Criar do zero</h4>
        <p>Defina nome, tipo de seleção e cobrança do zero. Ideal para adicionais únicos deste produto.</p>
        <span class="pv2-choice-card__footer">
          Criar do zero
          <span class="fa fa-arrow-right"></span>
        </span>
      </button>

      <button type="button" class="pv2-choice-card" (click)="selectChoice('library')">
        <div class="pv2-choice-card__icon is-library">
          <span class="fa fa-book"></span>
        </div>
        <h4>Da biblioteca</h4>
        <p>Reaproveite um adicional já criado em outro produto. Vincule ou duplique com um clique.</p>
        <span class="pv2-choice-card__footer">
          Ver {{ libraryItems.length }} {{ libraryItems.length === 1 ? 'adicional' : 'adicionais' }}
          <span class="fa fa-arrow-right"></span>
        </span>
      </button>
    </div>

    <ng-template #choiceProbingTpl>
      <div class="pv2-choice-grid">
        <div class="pv2-choice-card is-loading" *ngFor="let placeholder of [1, 2]">
          <div class="pv2-skel pv2-skel-choice-icon"></div>
          <div class="pv2-skel pv2-skel-line"></div>
          <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
        </div>
      </div>
    </ng-template>

    <div class="pv2-wizard-actions">
      <button type="button" class="pv2-ghost-btn" (click)="goBack()">Cancelar</button>
    </div>
  </section>

  <section class="pv2-wizard-shell" *ngIf="isCreateMode">
    <div class="pv2-wizard-grid" *ngIf="!isMobile; else mobileCreateWizardTpl">
      <div class="pv2-wizard-grid__main-column">
        <div class="pv2-shared-banner" *ngIf="hasSharedUsageInOtherProducts">
          <span class="fa fa-link"></span>
          <div class="pv2-shared-banner__content">
            <strong>Adicional compartilhado</strong>
            <span>Esta alteração irá afetar também nos outros produtos.</span>
            <div class="pv2-shared-banner__products" *ngIf="sharedProductNames.length">
              <span class="pv2-shared-banner__chip" *ngFor="let name of sharedProductNames.slice(0, 5)">{{ name }}</span>
              <span class="pv2-shared-banner__more" *ngIf="sharedProductNames.length > 5">+{{ sharedProductNames.length - 5 }} mais</span>
            </div>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="identityCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="optionsCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="quantityCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="wizardActionsTpl"></ng-container>
      </div>

      <div class="pv2-wizard-grid__side-column">
        <ng-container *ngTemplateOutlet="rulesCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="previewPanelTpl"></ng-container>
        <ng-container *ngTemplateOutlet="summaryCardTpl"></ng-container>
      </div>
    </div>

    <ng-template #mobileCreateWizardTpl>
      <div class="pv2-wizard-grid pv2-wizard-grid--stacked">
        <div class="pv2-shared-banner" *ngIf="hasSharedUsageInOtherProducts">
          <span class="fa fa-link"></span>
          <div class="pv2-shared-banner__content">
            <strong>Adicional compartilhado</strong>
            <span>Esta alteração irá afetar também nos outros produtos.</span>
            <div class="pv2-shared-banner__products" *ngIf="sharedProductNames.length">
              <span class="pv2-shared-banner__chip" *ngFor="let name of sharedProductNames.slice(0, 5)">{{ name }}</span>
              <span class="pv2-shared-banner__more" *ngIf="sharedProductNames.length > 5">+{{ sharedProductNames.length - 5 }} mais</span>
            </div>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="identityCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="rulesCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="quantityCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="optionsCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="summaryCardTpl"></ng-container>
        <ng-container *ngTemplateOutlet="wizardActionsTpl"></ng-container>
        <ng-container *ngTemplateOutlet="previewPanelTpl"></ng-container>
      </div>
    </ng-template>

    <ng-template #identityCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('identity')">
          <div class="pv2-section-card__icon is-identity">
            <span class="fa fa-pencil-alt"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Identidade</h4>
            <p>Nome e tipo de seleção</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('identity') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('identity')">
          <label class="pv2-form-field" data-draft-field="name">
            <span>Nome do adicional <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o nome irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            <input [(ngModel)]="groupDraft.name"
                   (ngModelChange)="onFieldChange()"
                   type="text"
                   placeholder="Ex: Escolha sua calda"
                   [class.is-invalid]="!!creationErrors.name"
                   [attr.aria-invalid]="creationErrors.name ? 'true' : null"
                   [disabled]="!podeEditar">
            <small class="pv2-field-error" *ngIf="creationErrors.name">{{ creationErrors.name }}</small>
          </label>

          <div class="pv2-form-section">
            <span class="pv2-form-section__label">Tipo de seleção <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o tipo de seleção irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            <div class="pv2-pill-grid">
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'single'"
                      (click)="onGroupTypeChange('single')"
                      [disabled]="!podeEditar">
                <span class="fa fa-dot-circle-o"></span> Única
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multiple'"
                      (click)="onGroupTypeChange('multiple')"
                      [disabled]="!podeEditar">
                <span class="fa fa-check-square"></span> Múltipla
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.type === 'multipleRepeat'"
                      (click)="onGroupTypeChange('multipleRepeat')"
                      [disabled]="!podeEditar">
                <span class="fa fa-clone"></span> Múltipla c/ rep.
              </button>
              <button type="button" class="pv2-pill" *ngIf="editor?.type === 'kit'" [class.is-active]="groupDraft.type === 'kit'"
                (click)="onGroupTypeChange('kit')" [disabled]="!podeEditar">Composição do kit</button>
            </div>
            <p *ngIf="erroLimiteAdicionais" class="text-danger mt-2" role="alert">{{ erroLimiteAdicionais }}</p>
          </div>
        </div>
      </article>
    </ng-template>


    <article class="pv2-section-card pv2-kit-card" *ngIf="groupDraft.type === 'kit' && groupDraft.raw?.configComponenteKit as config">
      <div class="pv2-section-card__head pv2-section-card__head--static">
        <div class="pv2-section-card__icon is-quantity">
          <span class="fa fa-cubes"></span>
        </div>
        <div class="pv2-section-card__title">
          <h4>Composição de {{ groupDraft.name || 'seu kit' }}</h4>
          <p>Quanto deste grupo entra em cada kit, como o cliente distribui entre as opções e como isso é cobrado.</p>
        </div>
      </div>

      <div class="pv2-section-card__body">
        <!-- 1. Quantidade -->
        <fieldset class="pv2-kit-block" [disabled]="!podeEditar">
          <div class="pv2-kit-block__header">
            <span class="pv2-kit-block__step">1</span>
            <div>
              <h5>Quantidade por kit</h5>
              <p>Este grupo sempre precisa ser completado. Quantas unidades dele cada kit leva?</p>
            </div>
          </div>

          <div class="pv2-kit-modes" role="radiogroup" aria-label="Modalidade de quantidade">
            <button type="button" class="pv2-quantity-card" role="radio"
                    [attr.aria-checked]="config.modalidadeQuantidade === 'FIXA'"
                    [class.is-active]="config.modalidadeQuantidade === 'FIXA'"
                    (click)="alterarModalidadeComponente(config, 'FIXA')">
              <div class="pv2-quantity-card__topline">
                <div class="pv2-quantity-card__headline"><h6>Quantidade fixa</h6></div>
                <span class="pv2-quantity-card__radio" [class.is-active]="config.modalidadeQuantidade === 'FIXA'"></span>
              </div>
              <p>Todo kit leva a mesma quantidade. Para levar mais, o cliente aumenta o número de kits.</p>
            </button>
            <button type="button" class="pv2-quantity-card" role="radio"
                    [attr.aria-checked]="config.modalidadeQuantidade === 'FECHADA'"
                    [class.is-active]="config.modalidadeQuantidade === 'FECHADA'"
                    (click)="alterarModalidadeComponente(config, 'FECHADA')">
              <div class="pv2-quantity-card__topline">
                <div class="pv2-quantity-card__headline"><h6>Quantidades cadastradas</h6></div>
                <span class="pv2-quantity-card__radio" [class.is-active]="config.modalidadeQuantidade === 'FECHADA'"></span>
              </div>
              <p>Você cadastra as opções (meio cento, cento…) e o cliente escolhe uma delas.</p>
            </button>
            <button type="button" class="pv2-quantity-card" role="radio"
                    [attr.aria-checked]="config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'"
                    [class.is-active]="config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'"
                    (click)="alterarModalidadeComponente(config, 'ESCOLHIDA_PELO_CLIENTE')">
              <div class="pv2-quantity-card__topline">
                <div class="pv2-quantity-card__headline"><h6>Cliente escolhe</h6></div>
                <span class="pv2-quantity-card__radio" [class.is-active]="config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'"></span>
              </div>
              <p>O cliente digita quantas unidades quer, dentro de um mínimo, um máximo e um passo.</p>
            </button>
          </div>

          <div class="pv2-kit-fields pv2-kit-fields--1" *ngIf="config.modalidadeQuantidade === 'FIXA'">
            <label class="pv2-form-field">
              <span>Unidades por kit</span>
              <span class="pv2-affix">
                <input type="number" min="1" step="1" inputmode="numeric" [(ngModel)]="config.qtdeFixa" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">un.</span>
              </span>
            </label>
          </div>

          <div class="pv2-kit-fields pv2-kit-fields--3" *ngIf="config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'">
            <label class="pv2-form-field">
              <span>Mínimo</span>
              <span class="pv2-affix">
                <input type="number" min="1" step="1" inputmode="numeric" [(ngModel)]="config.qtdeMinima" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">un.</span>
              </span>
            </label>
            <label class="pv2-form-field">
              <span>Máximo <em>opcional</em></span>
              <span class="pv2-affix">
                <input type="number" [min]="config.qtdeMinima || 1" step="1" inputmode="numeric" placeholder="Sem teto" [(ngModel)]="config.qtdeMaxima" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">un.</span>
              </span>
            </label>
            <label class="pv2-form-field">
              <span>Aumenta de</span>
              <span class="pv2-affix">
                <input type="number" min="1" step="1" inputmode="numeric" [(ngModel)]="config.incremento" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">em {{ config.incremento || 0 }}</span>
              </span>
            </label>
            <p class="pv2-field-hint pv2-kit-fields__hint">Em branco no máximo, o cliente pode levar quantas quiser. O passo é do total comprado e não obriga cada opção a seguir múltiplos.</p>
          </div>

          <div class="pv2-kit-qtds" [class.has-preco]="config.cobranca === 'POR_QUANTIDADE'" *ngIf="config.modalidadeQuantidade === 'FECHADA'">
            <div class="pv2-kit-qtds__head" *ngIf="config.quantidades?.length">
              <span>Nome</span>
              <span>Unidades</span>
              <span *ngIf="config.cobranca === 'POR_QUANTIDADE'">Preço</span>
              <span>Disponível</span>
              <span></span>
            </div>
            <div class="pv2-kit-qtds__row" *ngFor="let q of config.quantidades; let i = index">
              <label class="pv2-form-field">
                <span class="sr-only">Nome</span>
                <input [(ngModel)]="q.descricao" placeholder="Ex: Cento" (ngModelChange)="onFieldChange()" [disabled]="!podeEditar">
              </label>
              <label class="pv2-form-field">
                <span class="sr-only">Unidades</span>
                <span class="pv2-affix">
                  <input type="number" min="1" step="1" inputmode="numeric" [(ngModel)]="q.qtdeUnidades" (ngModelChange)="onFieldChange()" [disabled]="!podeEditar">
                  <span class="pv2-affix__suffix">un.</span>
                </span>
              </label>
              <label class="pv2-form-field" *ngIf="config.cobranca === 'POR_QUANTIDADE'">
                <span class="sr-only">Preço</span>
                <span class="pv2-affix pv2-affix--prefix">
                  <span class="pv2-affix__prefix">R$</span>
                  <input type="number" min="0" step="0.01" inputmode="decimal" [(ngModel)]="q.preco" (ngModelChange)="onFieldChange()" [disabled]="!podeEditarPrecos">
                </span>
              </label>
              <label class="pv2-toggle-switch pv2-kit-qtds__toggle" title="Disponível para venda">
                <input type="checkbox" [(ngModel)]="q.disponivel" (ngModelChange)="onFieldChange()" [disabled]="!podeEditar">
                <span class="pv2-toggle-switch__track"></span>
              </label>
              <button type="button" class="pv2-kit-qtds__remove" (click)="removerQuantidadeComponente(i)" [disabled]="!podeEditar" aria-label="Remover quantidade">
                <span class="fa fa-trash-alt"></span>
              </button>
            </div>
            <p class="pv2-kit-qtds__empty" *ngIf="!config.quantidades?.length">Nenhuma quantidade cadastrada ainda. Comece por uma, por exemplo “Cento · 100 un.”.</p>
            <button type="button" class="pv2-ghost-btn pv2-kit-qtds__add" (click)="adicionarQuantidadeComponente()" [disabled]="!podeEditar">
              <span class="fa fa-plus"></span> Adicionar quantidade
            </button>
          </div>
        </fieldset>

        <!-- 2. Distribuição -->
        <fieldset class="pv2-kit-block" [disabled]="!podeEditar">
          <div class="pv2-kit-block__header">
            <span class="pv2-kit-block__step">2</span>
            <div>
              <h5>Distribuição entre as opções</h5>
              <p>Como o cliente divide as unidades entre as opções deste grupo. Regras independentes da quantidade do kit.</p>
            </div>
          </div>
          <div class="pv2-kit-fields pv2-kit-fields--2">
            <label class="pv2-form-field">
              <span>Mínimo por opção escolhida</span>
              <span class="pv2-affix">
                <input type="number" min="1" step="1" inputmode="numeric" [(ngModel)]="config.qtdeMinimaPorOpcao" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">un.</span>
              </span>
            </label>
            <label class="pv2-form-field">
              <span>Máximo de opções diferentes <em>opcional</em></span>
              <span class="pv2-affix">
                <input type="number" min="1" step="1" inputmode="numeric" placeholder="Sem limite" [(ngModel)]="config.qtdeMaximaDeOpcoes" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">opções</span>
              </span>
            </label>
          </div>
        </fieldset>

        <!-- 3. Cobrança -->
        <fieldset class="pv2-kit-block" [disabled]="!podeEditarPrecos">
          <div class="pv2-kit-block__header">
            <span class="pv2-kit-block__step">3</span>
            <div>
              <h5>Cobrança</h5>
              <p>Preço-base do kit: <strong>{{ editor.basePrice | currency:'BRL' }}</strong>. O que este grupo cobra e os extras por unidade das opções são somados a ele.</p>
            </div>
          </div>

          <div class="pv2-kit-modes pv2-kit-modes--2" role="radiogroup" aria-label="Forma de cobrança">
            <button type="button" class="pv2-quantity-card" role="radio"
                    [attr.aria-checked]="config.cobranca === 'INCLUIDO'"
                    [class.is-active]="config.cobranca === 'INCLUIDO'"
                    (click)="config.cobranca = 'INCLUIDO'; onFieldChange()">
              <div class="pv2-quantity-card__topline">
                <div class="pv2-quantity-card__headline"><h6>Incluído no preço do kit</h6></div>
                <span class="pv2-quantity-card__radio" [class.is-active]="config.cobranca === 'INCLUIDO'"></span>
              </div>
              <p>Este grupo não cobra nada além do preço-base. Só os extras por unidade das opções, se houver.</p>
            </button>
            <button type="button" class="pv2-quantity-card" role="radio"
                    [attr.aria-checked]="config.cobranca === 'POR_QUANTIDADE'"
                    [class.is-active]="config.cobranca === 'POR_QUANTIDADE'"
                    (click)="config.cobranca = 'POR_QUANTIDADE'; onFieldChange()">
              <div class="pv2-quantity-card__topline">
                <div class="pv2-quantity-card__headline"><h6>Cobrar pela quantidade</h6></div>
                <span class="pv2-quantity-card__radio" [class.is-active]="config.cobranca === 'POR_QUANTIDADE'"></span>
              </div>
              <p>{{ config.modalidadeQuantidade === 'FECHADA' ? 'Cada quantidade cadastrada tem o seu preço.' : config.modalidadeQuantidade === 'FIXA' ? 'Um valor fixo por kit é somado ao preço-base.' : 'O valor é proporcional às unidades escolhidas, a partir de um preço de referência.' }}</p>
            </button>
          </div>

          <div class="pv2-kit-fields pv2-kit-fields--1" *ngIf="config.cobranca === 'POR_QUANTIDADE' && config.modalidadeQuantidade === 'FIXA'">
            <label class="pv2-form-field">
              <span>Preço deste grupo por kit</span>
              <span class="pv2-affix pv2-affix--prefix">
                <span class="pv2-affix__prefix">R$</span>
                <input type="number" min="0" step="0.01" inputmode="decimal" [(ngModel)]="config.preco" (ngModelChange)="onFieldChange()">
              </span>
            </label>
          </div>

          <div class="pv2-kit-fields pv2-kit-fields--ref" *ngIf="config.cobranca === 'POR_QUANTIDADE' && config.modalidadeQuantidade === 'ESCOLHIDA_PELO_CLIENTE'">
            <label class="pv2-form-field">
              <span>Preço de referência</span>
              <span class="pv2-affix pv2-affix--prefix">
                <span class="pv2-affix__prefix">R$</span>
                <input type="number" min="0" step="0.01" inputmode="decimal" [(ngModel)]="config.precoReferencia" (ngModelChange)="onFieldChange()">
              </span>
            </label>
            <span class="pv2-kit-fields__joiner">por</span>
            <label class="pv2-form-field">
              <span>Unidades</span>
              <span class="pv2-affix">
                <input type="number" min="1" step="1" inputmode="numeric" [(ngModel)]="config.qtdeReferencia" (ngModelChange)="onFieldChange()">
                <span class="pv2-affix__suffix">un.</span>
              </span>
            </label>
            <p class="pv2-field-hint pv2-kit-fields__hint">A referência só define a conta. Ela não obriga o cliente a comprar múltiplos dela.</p>
          </div>
        </fieldset>

        <!-- Prévia -->
        <div class="pv2-kit-preview" *ngIf="obtenhaPreviaComponenteKit(config) as previa">
          <span class="pv2-kit-preview__label"><span class="fa fa-eye"></span> Como o cliente vai comprar</span>
          <ul class="pv2-kit-preview__list">
            <li *ngFor="let linha of previa">{{ linha }}</li>
          </ul>
        </div>
      </div>
    </article>

    <ng-template #rulesCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('rules')">
          <div class="pv2-section-card__icon is-rules">
            <span class="fa fa-shield-alt"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Regras</h4>
            <p>Obrigatoriedade, limites e cobrança</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('rules') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('rules') && groupDraft.type !== 'kit'">
          <label class="pv2-toggle-row pv2-toggle-box">
            <div class="pv2-toggle-box__label">
              <span class="fa fa-info-circle"></span>
              <span>Obrigatório <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Ativar ou desativar a obrigatoriedade irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            </div>
            <div class="pv2-toggle-switch">
              <input type="checkbox" [(ngModel)]="groupDraft.required" (ngModelChange)="onRequiredChange($event)"
                     [disabled]="!podeEditar">
              <span class="pv2-toggle-switch__track"></span>
            </div>
          </label>

          <div class="pv2-form-grid" *ngIf="groupDraft.type !== 'single'">
            <label class="pv2-form-field">
              <span>Mínimo <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o mínimo irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span></span></span>
              <input [(ngModel)]="groupDraft.min" (ngModelChange)="onMinimumChange($event)" type="number" min="0"
                     [disabled]="!podeEditar">
            </label>
            <label class="pv2-form-field">
              <span>Máximo <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o máximo irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span></span></span>
              <input [(ngModel)]="groupDraft.max" (ngModelChange)="onMaximumChange($event)" type="number" min="1"
                     [disabled]="!podeEditar">
            </label>
          </div>

          <div class="pv2-form-section">
            <span class="pv2-form-section__label">Tipo de cobrança <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Alterar o tipo de cobrança irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
            <div class="pv2-pill-grid">
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'soma'"
                      (click)="groupDraft.chargeType = 'soma'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-plus-circle"></span> Soma
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'media'"
                      (click)="groupDraft.chargeType = 'media'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-balance-scale"></span> Média
              </button>
              <button type="button" class="pv2-pill" [class.is-active]="groupDraft.chargeType === 'maior'"
                      (click)="groupDraft.chargeType = 'maior'; onFieldChange()"
                      [disabled]="!podeEditar">
                <span class="fa fa-arrow-up"></span> Maior
              </button>
            </div>
          </div>
        </div>
      </article>
    </ng-template>

    <ng-template #optionsCardTpl>
      <article class="pv2-section-card pv2-section-card--options">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('options')">
          <div class="pv2-section-card__icon is-options">
            <span class="fa fa-th-large"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Opções</h4>
            <p>Itens que o cliente poderá escolher</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('options') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('options')">
          <section class="pv2-add-option-section" data-draft-field="options">
            <div class="pv2-add-option-section__header">
              <span class="pv2-add-option-section__label">Adicionar opções <span class="pv2-shared-field-tag" *ngIf="hasSharedUsageInOtherProducts" kendoTooltip title="Adicionar ou remover opções irá refletir em todos os produtos que usam este adicional."><span class="fa fa-link"></span> Compartilhado</span></span>
              <span class="pv2-add-option-section__hint">Pressione Enter para adicionar</span>
            </div>
            <small class="pv2-field-error" *ngIf="creationErrors.options">{{ creationErrors.options }}</small>
            <div class="pv2-add-option-row">
              <input type="text" class="pv2-add-option-row__name"
                     #optionNameInput
                     [(ngModel)]="newOptionName"
                     placeholder="Nome da opção (Ex: Calda de morango)"
                     (keydown.enter)="addOptionFromInput($event)">
              <div class="pv2-add-option-row__price-wrap">
                <span class="pv2-add-option-row__prefix">R$</span>
                <input type="text" class="pv2-add-option-row__price"
                       [(ngModel)]="newOptionPrice"
                       placeholder="0,00"
                       inputmode="decimal"
                       (keydown.enter)="addOptionFromInput($event)">
              </div>
              <button type="button" class="pv2-add-option-row__btn"
                      [disabled]="!newOptionName.trim()"
                      (click)="addOptionFromInput($event)">
                <span class="fa fa-plus"></span>
              </button>
            </div>
          </section>

          <ng-container *ngIf="hasOptions; else emptyOptionsTpl">
            <div class="pv2-group-mode-switch" [ngClass]="modeThemeClass">
              <button type="button" class="pv2-group-mode-switch__btn"
                      [class.is-active]="isReviewMode"
                      [ngClass]="{'is-editar': isReviewMode}"
                      (click)="setOptionMode('review')">
                <span class="fa fa-pencil"></span>
                Editar
              </button>
              <button type="button" class="pv2-group-mode-switch__btn"
                      [class.is-active]="isActivationMode"
                      [ngClass]="{'is-onoff': isActivationMode}"
                      (click)="setOptionMode('activation')">
                <span class="fa fa-toggle-on"></span>
                Ativar/Desativar
              </button>
              <button type="button" class="pv2-group-mode-switch__btn"
                      [class.is-active]="isBatchPriceMode"
                      [ngClass]="{'is-lote': isBatchPriceMode}"
                      (click)="setOptionMode('batch-price')">
                <span class="fa fa-th"></span>
                Preço em massa
              </button>
            </div>

            <div class="pv2-gd-banner" [ngClass]="modeThemeClass">
              <span class="pv2-gd-banner__icon">
                <span class="fa" [ngClass]="{
                  'fa-check-circle': isActivationMode,
                  'fa-pencil': isReviewMode,
                  'fa-check-square': isBatchPriceMode
                }"></span>
              </span>
              <span *ngIf="isActivationMode">Toque para ativar ou desativar opções.</span>
              <span *ngIf="isReviewMode">Toque em uma opção para editar nome, preço e detalhes.</span>
              <span *ngIf="isBatchPriceMode">Selecione várias opções para aplicar ações em massa.</span>
            </div>

            <section class="pv2-group-detail-options-shell" *ngIf="showSearchAndSort">
              <div class="pv2-gd-toolbar">
                <label class="pv2-search pv2-gd-search">
                  <span class="fa fa-search"></span>
                  <input [ngModel]="optionSearch" (ngModelChange)="setOptionSearch($event)"
                         type="text" placeholder="Pesquisar opções...">
                </label>
                <div class="pv2-gd-sort-row">
                  <div class="pv2-gd-sort">
                    <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'name-asc'"
                            (click)="setOptionSort('name-asc')">A-Z</button>
                    <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'price-asc'"
                            (click)="setOptionSort('price-asc')">R$ &#8593;</button>
                    <button type="button" class="pv2-chip" [class.is-active]="optionSort === 'price-desc'"
                            (click)="setOptionSort('price-desc')">R$ &#8595;</button>
                  </div>
                  <span class="pv2-gd-item-count">{{ filteredOptions.length }} itens</span>
                </div>
              </div>
            </section>

            <div class="pv2-gd-batch-bar" *ngIf="isBatchPriceMode">
              <div class="pv2-gd-batch-bar__counter">
                <strong>{{ batchSelectedCount }}/{{ filteredOptions.length }}</strong>
                <button type="button" class="pv2-chip" (click)="selectAllFilteredBatchOptions()">Todos</button>
                <button type="button" class="pv2-chip" (click)="clearBatchSelection()">Nenhum</button>
              </div>
              <div class="pv2-gd-batch-bar__actions">
                <button type="button" class="pv2-primary-btn pv2-gd-batch-bar__price-btn"
                        (click)="openBatchSheet()">
                  Alterar preço
                </button>
                <button type="button" class="pv2-gd-batch-bar__on-btn"
                        (click)="applyBatchAvailability(true)">
                  <span class="fa fa-check"></span> Ativar
                </button>
                <button type="button" class="pv2-gd-batch-bar__off-btn"
                        (click)="applyBatchAvailability(false)">
                  <span class="fa fa-ban"></span> Desativar
                </button>
              </div>
            </div>

            <ng-template #optionTooltipTpl let-option>
              <div class="pv2-option-tooltip">
                <div class="pv2-option-tooltip__header">
                  <strong>{{ option.name || 'Sem nome' }}</strong>
                  <span>R$ {{ option.price | number:'1.2-2':'pt' }}</span>
                </div>
                <p class="pv2-option-tooltip__description" *ngIf="option.description; else noOptionDescriptionTpl">{{ option.description }}</p>
                <ng-template #noOptionDescriptionTpl>
                  <p class="pv2-option-tooltip__description is-empty">Sem descrição cadastrada.</p>
                </ng-template>
                <dl class="pv2-option-tooltip__facts">
                  <div><dt><span class="fa fa-check-circle" aria-hidden="true"></span>Status</dt><dd>{{ option.active === false ? 'Pausada' : 'Ativa' }}</dd></div>
                  <div><dt><span class="fa fa-motorcycle" aria-hidden="true"></span>Delivery</dt><dd>{{ option.disponivelParaDelivery !== false ? 'Exibida' : 'Oculta' }}</dd></div>
                  <div><dt><span class="fa fa-utensils" aria-hidden="true"></span>Mesa</dt><dd>{{ option.disponivelNaMesa !== false ? 'Exibida' : 'Oculta' }}</dd></div>
                  <div><dt><span class="fa fa-barcode" aria-hidden="true"></span>Código PDV</dt><dd>{{ option.codigoPdv || 'Não informado' }}</dd></div>
                  <div><dt><span class="fa fa-list-ol" aria-hidden="true"></span>Quantidade máxima</dt><dd>{{ option.qtdeMaxima > 0 ? option.qtdeMaxima : 'Sem limite' }}</dd></div>
                </dl>
              </div>
            </ng-template>

            <ng-template #optionDetailsTpl let-option>
              <span class="pv2-option-chip__details">
                <span class="pv2-option-chip__meta">
                  <span class="pv2-option-chip__availability" [class.is-paused]="option.active === false"
                        role="img" [attr.aria-label]="option.active === false ? 'Pausada' : 'Ativa'">
                    <span class="fa" [ngClass]="option.active === false ? 'fa-pause-circle' : 'fa-check-circle'" aria-hidden="true"></span>
                  </span>
                  <span *ngIf="option.disponivelParaDelivery !== false" role="img" aria-label="Exibida no delivery">
                    <span class="fa fa-motorcycle" aria-hidden="true"></span>
                  </span>
                  <span *ngIf="option.disponivelNaMesa !== false" role="img" aria-label="Exibida na mesa">
                    <span class="fa fa-utensils" aria-hidden="true"></span>
                  </span>
                  <span *ngIf="option.disponivelParaDelivery === false && option.disponivelNaMesa === false"
                        role="img" aria-label="Oculta nos cardápios">
                    <span class="fa fa-eye-slash" aria-hidden="true"></span>
                  </span>
                  <span *ngIf="option.codigoPdv" class="pv2-option-chip__pdv">
                    <span class="fa fa-barcode" aria-hidden="true"></span>
                    <span>PDV {{ option.codigoPdv }}</span>
                  </span>
                  <span *ngIf="option.qtdeMaxima > 0">Máx. {{ option.qtdeMaxima }}</span>
                </span>
              </span>
            </ng-template>

            <ng-template #optionThumbTpl let-option let-badge="badge" let-on="on">
              <span class="pv2-option-chip__thumb">
                <img [src]="resolveOptionImageUrl(option.linkImagem)" alt=""
                     width="40" height="40" loading="lazy" decoding="async"
                     (error)="onOptionImageError(option)">
                <span class="pv2-option-chip__thumb-badge" *ngIf="badge"
                      [ngClass]="'is-' + badge" [class.is-on]="on">
                  <span class="fa" [ngClass]="badge === 'edit' ? 'fa-pencil-alt' : 'fa-check'" aria-hidden="true"></span>
                </span>
              </span>
            </ng-template>

            <div class="pv2-gd-chip-flow" [ngClass]="modeThemeClass"
                 *ngIf="filteredOptions.length; else emptyFilterTpl"
                 kendoTooltip #optionTooltipDirective="kendoTooltip"
                 filter=".pv2-option-chip"
                 [tooltipTemplate]="optionTooltipContent"
                 tooltipClass="pv2-option-kendo-tooltip"
                 position="top" [showAfter]="180" [tooltipWidth]="320"
                 (scroll)="optionTooltipDirective.hide()">
              <ng-template #optionTooltipContent let-anchor>
                <ng-container *ngIf="optionForTooltipAnchor(anchor) as tipOption">
                  <ng-container *ngTemplateOutlet="optionTooltipTpl; context: {$implicit: tipOption}"></ng-container>
                </ng-container>
              </ng-template>
              <ng-container *ngIf="isActivationMode">
                <button type="button" class="pv2-option-chip is-mode-onoff"
                        *ngFor="let option of filteredOptions; let i = index; trackBy: trackByOption"
                        #optionAnchor [attr.data-option-idx]="i"
                        (focus)="optionTooltipDirective.show(optionAnchor)"
                        (blur)="optionTooltipDirective.hide()"
                        (keydown.escape)="optionTooltipDirective.hide()"
                        [class.is-active]="option.active !== false"
                        [class.is-inactive]="option.active === false"
                        [class.has-image]="hasOptionImage(option)"
                        (click)="optionTooltipDirective.hide(); onChipClickOnOff(option)">
                  <ng-container *ngIf="hasOptionImage(option); else statusDotTpl">
                    <ng-container *ngTemplateOutlet="optionThumbTpl; context: {$implicit: option, badge: 'status', on: option.active !== false}"></ng-container>
                  </ng-container>
                  <ng-template #statusDotTpl>
                    <span class="pv2-option-chip__status-dot" [class.is-on]="option.active !== false">
                      <span class="fa fa-check" *ngIf="option.active !== false"></span>
                    </span>
                  </ng-template>
                  <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                  <span class="pv2-option-chip__price">R${{ option.price | number:'1.2-2':'pt' }}</span>
                  <ng-container *ngTemplateOutlet="optionDetailsTpl; context: {$implicit: option}"></ng-container>
                </button>
              </ng-container>

              <ng-container *ngIf="isReviewMode">
                <button type="button" class="pv2-option-chip is-mode-editar"
                        *ngFor="let option of filteredOptions; let i = index; trackBy: trackByOption"
                        #optionAnchor [attr.data-option-idx]="i"
                        (focus)="optionTooltipDirective.show(optionAnchor)"
                        (blur)="optionTooltipDirective.hide()"
                        (keydown.escape)="optionTooltipDirective.hide()"
                        [class.is-active]="option.active !== false"
                        [class.is-inactive]="option.active === false"
                        [class.is-editing]="isEditingOption(option)"
                        [class.has-image]="hasOptionImage(option)"
                        (click)="optionTooltipDirective.hide(); onChipClickEditar(option)">
                  <ng-container *ngIf="hasOptionImage(option); else editDotTpl">
                    <ng-container *ngTemplateOutlet="optionThumbTpl; context: {$implicit: option, badge: 'edit'}"></ng-container>
                  </ng-container>
                  <ng-template #editDotTpl>
                    <span class="pv2-option-chip__edit-dot">
                      <span class="fa fa-pencil-alt"></span>
                    </span>
                  </ng-template>
                  <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                  <span class="pv2-option-chip__price">R${{ option.price | number:'1.2-2':'pt' }}</span>
                  <ng-container *ngTemplateOutlet="optionDetailsTpl; context: {$implicit: option}"></ng-container>
                </button>
              </ng-container>

              <ng-container *ngIf="isBatchPriceMode">
                <button type="button" class="pv2-option-chip is-mode-lote"
                        *ngFor="let option of filteredOptions; let i = index; trackBy: trackByOption"
                        #optionAnchor [attr.data-option-idx]="i"
                        (focus)="optionTooltipDirective.show(optionAnchor)"
                        (blur)="optionTooltipDirective.hide()"
                        (keydown.escape)="optionTooltipDirective.hide()"
                        [class.is-inactive]="option.active === false"
                        [class.is-selected]="isBatchOptionSelected(option)"
                        [class.has-image]="hasOptionImage(option)"
                        (click)="optionTooltipDirective.hide(); onChipClickLote(option)">
                  <ng-container *ngIf="hasOptionImage(option)">
                    <ng-container *ngTemplateOutlet="optionThumbTpl; context: {$implicit: option, badge: isBatchOptionSelected(option) ? 'selected' : null}"></ng-container>
                  </ng-container>
                  <span class="pv2-option-chip__name">{{ option.name || 'Sem nome' }}</span>
                  <span class="pv2-option-chip__price">R${{ option.price | number:'1.2-2':'pt' }}</span>
                  <ng-container *ngTemplateOutlet="optionDetailsTpl; context: {$implicit: option}"></ng-container>
                </button>
              </ng-container>
              <button type="button" class="pv2-new-option-chip pv2-new-option-chip--dashed"
                      *ngIf="podeEditar"
                      (click)="scrollToOptionInput()">
                <span class="fa fa-plus"></span>
                Nova opção
              </button>
            </div>
          </ng-container>

          <ng-template #emptyOptionsTpl>
            <section class="pv2-adicional-empty">
              <div class="pv2-adicional-empty__icon">📋</div>
              <h3>Nenhuma opção adicionada</h3>
              <p>Adicione pelo menos 1 opção para salvar o adicional.</p>
            </section>
          </ng-template>

          <ng-template #emptyFilterTpl>
            <div class="pv2-empty pv2-empty--inline pv2-empty--compact" *ngIf="showSearchAndSort">
              <h3>Nenhuma opção encontrada</h3>
              <p>Ajuste a busca para voltar a exibir as opções deste adicional.</p>
            </div>
          </ng-template>
        </div>
      </article>
    </ng-template>

     <ng-template #quantityCardTpl>
       <article class="pv2-section-card pv2-section-card--quantity">
         <button type="button" class="pv2-section-card__head" (click)="toggleSection('quantity')">
           <div class="pv2-section-card__icon is-quantity">
             <span class="fa fa-clone"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Comportamento do adicional</h4>
            <p>Como esse item entra no pedido</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('quantity') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('quantity')">
          <section class="pv2-quantity-mode">
            <div class="pv2-quantity-mode__header">
              <p>Escolha se ele acompanha cada unidade do produto ou se entra uma vez no pedido.</p>
            </div>

            <div class="pv2-quantity-mode__grid">
              <button type="button"
                      class="pv2-quantity-card"
                      [class.is-active]="groupDraft.multiplicaQuantidadeProduto !== false"
                      (click)="groupDraft.multiplicaQuantidadeProduto = true; onFieldChange()"
                      [disabled]="!podeEditar">
                <div class="pv2-quantity-card__topline">
                  <div class="pv2-quantity-card__headline">
                    <h6>{{ getQuantityModeTitle(true) }}</h6>
                  </div>
                  <span class="pv2-quantity-card__radio" [class.is-active]="groupDraft.multiplicaQuantidadeProduto !== false"></span>
                </div>
                <p>{{ getQuantityModeDescription(true) }}</p>
                <div class="pv2-quantity-card__example" *ngIf="groupDraft.multiplicaQuantidadeProduto !== false">{{ getQuantityModeExample(true) }}</div>
              </button>

              <button type="button"
                      class="pv2-quantity-card"
                      [class.is-active]="groupDraft.multiplicaQuantidadeProduto === false"
                      (click)="groupDraft.multiplicaQuantidadeProduto = false; onFieldChange()"
                      [disabled]="!podeEditar">
                <div class="pv2-quantity-card__topline">
                  <div class="pv2-quantity-card__headline">
                    <h6>{{ getQuantityModeTitle(false) }}</h6>
                  </div>
                  <span class="pv2-quantity-card__radio" [class.is-active]="groupDraft.multiplicaQuantidadeProduto === false"></span>
                </div>
                <p>{{ getQuantityModeDescription(false) }}</p>
                <div class="pv2-quantity-card__example" *ngIf="groupDraft.multiplicaQuantidadeProduto === false">{{ getQuantityModeExample(false) }}</div>
              </button>
            </div>
         </section>
       </div>
     </article>
    </ng-template>
     <ng-template #summaryCardTpl>
      <article class="pv2-section-card">
        <button type="button" class="pv2-section-card__head" (click)="toggleSection('summary')">
          <div class="pv2-section-card__icon is-summary">
            <span class="fa fa-clipboard-list"></span>
          </div>
          <div class="pv2-section-card__title">
            <h4>Resumo e ações</h4>
            <p>Revise o escopo do adicional</p>
          </div>
          <span class="fa" [ngClass]="isSectionExpanded('summary') ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
        </button>

        <div class="pv2-section-card__body" *ngIf="isSectionExpanded('summary')">
          <div class="pv2-wizard-summary">
            <div class="pv2-wizard-summary__item">
              <span class="pv2-wizard-summary__label">Escopo</span>
              <strong>{{ groupDraft.shared ? ('Compartilhado em ' + groupDraft.sharedCount + ' produtos') : 'Só neste produto' }}</strong>
              <div class="pv2-wizard-summary__products" *ngIf="sharedProductNames.length">
                <span class="pv2-wizard-summary__product-chip" *ngFor="let name of sharedProductNames.slice(0, 5)">{{ name }}</span>
                <span class="pv2-wizard-summary__more" *ngIf="sharedProductNames.length > 5">+{{ sharedProductNames.length - 5 }} mais</span>
              </div>
            </div>
            <div class="pv2-wizard-summary__item">
              <span class="pv2-wizard-summary__label">Seleção</span>
              <strong>{{ groupDraft.type === 'kit' ? 'Composição do kit' : groupDraft.type === 'single' ? 'Única' : groupDraft.type === 'multipleRepeat' ? 'Múltipla c/ repetição' : 'Múltipla' }}</strong>
            </div>
            <div class="pv2-wizard-summary__item">
              <span class="pv2-wizard-summary__label">Opções</span>
              <strong>{{ groupDraft.options.length }} cadastradas</strong>
            </div>
          </div>

          <button type="button" class="pv2-remove-group-btn"
                  *ngIf="mode === 'edit'"
                  (click)="requestDelete()"
                  [disabled]="!podeEditar">
            <span class="fa fa-trash"></span>
            {{ groupDraft.shared ? 'Remover deste produto' : 'Excluir adicional' }}
          </button>
        </div>
      </article>
    </ng-template>

    <ng-template #wizardActionsTpl>
      <div class="pv2-wizard-actions pv2-wizard-actions--condensed is-end">
        <button type="button" class="pv2-ghost-btn" (click)="goBackFromWizard()">
          <span class="fa fa-arrow-left"></span>
          Voltar
        </button>
        <button type="button" class="pv2-ghost-btn" (click)="onSave()" [disabled]="!!erroLimiteAdicionais">
          Salvar
        </button>
        <button type="button" class="pv2-primary-btn pv2-wizard-actions__primary"
                (click)="onSaveAndClose()" [disabled]="!!erroLimiteAdicionais">
          Salvar e Fechar
          <span class="fa fa-check"></span>
        </button>
      </div>
    </ng-template>

    <ng-template #previewPanelTpl>
      <aside class="pv2-preview-panel">
        <span class="pv2-preview-panel__eyebrow"><span class="fa fa-eye" aria-hidden="true"></span> Visão do cliente</span>
        <article class="pv2-preview-card-inline">
          <h4>{{ previewTitle }}</h4>
          <span class="pv2-preview-card-inline__badge" [class.is-optional]="!previewRequired">
            {{ previewRequired ? 'Obrigatório' : 'Opcional' }}
          </span>
          <p class="pv2-preview-card-inline__meta">{{ previewSelectionText }}</p>

          <div class="pv2-preview-card-inline__options" *ngIf="previewOptions.length; else previewEmptyTpl">
            <label class="pv2-preview-card-inline__option" *ngFor="let option of previewOptions">
              <input [type]="groupDraft.type === 'single' ? 'radio' : 'checkbox'" disabled tabindex="-1" aria-hidden="true">
              <span>{{ option }}</span>
            </label>
          </div>
          <ng-template #previewEmptyTpl>
            <div class="pv2-preview-card-inline__empty">As opções aparecerão aqui conforme você configurar o adicional.</div>
          </ng-template>

          <footer class="pv2-preview-card-inline__footer">
            <span class="fa fa-eye"></span>
            Prévia atualizada enquanto você edita
          </footer>
        </article>

        <article class="pv2-preview-tip-card" *ngIf="groupDraft.shared">
          <div class="pv2-preview-tip-card__title">
            <span class="fa" [ngClass]="isLibraryMode ? 'fa-info-circle' : (groupDraft.shared ? 'fa-link' : 'fa-eye')"></span>
            {{ previewHintTitle }}
          </div>
          <p>{{ previewHintText }}</p>
        </article>
      </aside>
    </ng-template>
  </section>

  <section class="pv2-wizard-shell" *ngIf="isLibraryMode">
    <div class="pv2-wizard-grid">
      <article class="pv2-wizard-main-card pv2-library-main-card">
        <header class="pv2-library-header">
          <button type="button" class="pv2-library-header__back" (click)="goBackFromWizard()">
            <span class="fa fa-chevron-left"></span>
          </button>
          <div>
            <h3>Vincular Adicional</h3>
            <p>Grupo de complementos</p>
          </div>
        </header>

        <div class="pv2-library-product-bar">
          <span><strong class="pv2-library-product-bar__label">PRODUTO:</strong> {{ editor?.name }}</span>
        </div>

        <label class="pv2-search pv2-library-search">
          <span class="fa fa-search"></span>
          <input [ngModel]="librarySearch"
                 (ngModelChange)="onLibrarySearchChange($event)"
                 type="text"
                 placeholder="Buscar por adicional ou produto...">
        </label>

        <div class="pv2-chip-row">
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Todos'" (click)="setLibraryFilter('Todos')">Todos</button>
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Compartilhados'" (click)="setLibraryFilter('Compartilhados')">Compartilhados</button>
          <button type="button" class="pv2-chip" [class.is-active]="libraryFilter === 'Exclusivos'" (click)="setLibraryFilter('Exclusivos')">Exclusivos</button>
        </div>

        <p class="pv2-library-hint-text">
          <span class="fa fa-info-circle"></span>
          Marque vários grupos para vincular de uma vez; clique em um deles para ver a prévia
        </p>

        <div class="pv2-library-list" *ngIf="!libraryLoading; else libraryLoadingTpl">

          <div class="pv2-library-product-group"
               *ngFor="let group of filteredLibraryProductGroups; trackBy: trackByLibraryProductGroup"
               [class.is-shared-group]="group.productId === -1"
               [class.is-expanded]="group.expanded">

            <button type="button" class="pv2-library-product-group__header"
                    (click)="toggleProductGroup(group.productId)">
              <div class="pv2-library-product-group__icon"
                   [class.is-shared]="group.productId === -1">
                <span class="fa" [ngClass]="group.productId === -1
                  ? 'fa-share-alt'
                  : getProductTypeIcon(group.productType)"></span>
              </div>
              <div class="pv2-library-product-group__info">
                <h4>{{ group.productName }}</h4>
                <span class="pv2-library-product-group__count">
                  {{ group.adicionais.length }} adiciona{{ group.adicionais.length === 1 ? 'l' : 'is' }}
                </span>
              </div>
              <span class="fa pv2-library-product-group__chevron"
                    [ngClass]="group.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></span>
            </button>

            <div class="pv2-library-product-group__body" *ngIf="group.expanded">
              <article class="pv2-library-compact-card"
                       *ngFor="let item of group.adicionais; trackBy: trackByLibraryItem"
                       [class.is-selected]="isLibraryGroupSelected(item)"
                       [class.is-focused]="isLibraryGroupFocused(item)"
                       (click)="toggleLibraryGroupSelection(item)">
                <label class="pv2-library-compact-card__selector" (click)="$event.stopPropagation()">
                  <input type="checkbox"
                         [checked]="isLibraryGroupSelected(item)"
                         (change)="toggleLibraryGroupSelection(item)">
                  <span aria-hidden="true"><i class="fa fa-check"></i></span>
                  <span class="sr-only">Selecionar {{ item.name }}</span>
                </label>
                <div class="pv2-library-compact-card__main">
                  <div class="pv2-library-compact-card__name-row">
                    <h5>{{ item.name }}</h5>
                    <span class="pv2-library-compact-card__shared-badge" *ngIf="item.sharedCount > 1">
                      <span class="fa fa-share-alt"></span> Compartilhado · {{ item.sharedCount }} produtos
                    </span>
                    <span class="pv2-library-compact-card__scope-badge is-exclusive" *ngIf="item.sharedCount === 1">
                      <span class="fa fa-lock"></span> Exclusivo · 1 produto
                    </span>
                    <span class="pv2-library-compact-card__scope-badge is-unlinked" *ngIf="item.sharedCount === 0">
                      Sem vínculo
                    </span>
                    <span class="pv2-library-compact-card__requirement-badge" [class.is-optional]="!item.required">
                      {{ item.required ? 'Obrigatório' : 'Opcional' }}
                    </span>
                    <span class="pv2-library-compact-card__linked-badge" *ngIf="isLibraryGroupLinked(item)">
                      <span class="fa fa-check"></span> Vinculado
                    </span>
                  </div>
                  <span class="pv2-library-compact-card__preview" *ngIf="item.previewOptions?.length">
                    {{ item.previewOptions.join(', ') }}
                  </span>
                  <span class="pv2-library-compact-card__rules">
                    {{ item.description }}
                  </span>
                  <div class="pv2-library-compact-card__products"
                       *ngIf="group.productId === -1 && item.sharedProductNames?.length">
                    <span class="pv2-library-compact-card__product-chip"
                          *ngFor="let pName of item.sharedProductNames.slice(0, 4)">{{ pName }}</span>
                    <span class="pv2-library-compact-card__products-more"
                          *ngIf="item.sharedProductNames.length > 4">
                      +{{ item.sharedProductNames.length - 4 }} mais
                    </span>
                  </div>
                </div>
              </article>
            </div>
          </div>

          <div class="pv2-empty pv2-empty--inline" *ngIf="!totalFilteredAdicionais">
            <h3>Nenhum adicional encontrado</h3>
            <p>Ajuste a busca para encontrar um adicional existente no catálogo.</p>
          </div>
        </div>

        <ng-template #libraryLoadingTpl>
          <div class="pv2-library-product-group" *ngFor="let skeleton of [1,2,3]">
            <div class="pv2-library-product-group__header" style="pointer-events: none;">
              <div class="pv2-library-product-group__icon">
                <div class="pv2-skel pv2-skel-circle"></div>
              </div>
              <div class="pv2-library-product-group__info">
                <div class="pv2-skel pv2-skel-line"></div>
                <div class="pv2-skel pv2-skel-line pv2-skel-line-sm"></div>
              </div>
            </div>
          </div>
        </ng-template>
      </article>

      <aside class="pv2-preview-panel" *ngIf="!isMobile">
        <span class="pv2-preview-panel__eyebrow">Visão do cliente</span>
        <article class="pv2-preview-card-inline">
          <h4>{{ previewTitle }}</h4>
          <span class="pv2-preview-card-inline__badge" [class.is-optional]="!previewRequired">
            {{ previewRequired ? 'Obrigatório' : 'Opcional' }}
          </span>
          <p class="pv2-preview-card-inline__meta">{{ previewSelectionText }}</p>

          <div class="pv2-preview-card-inline__options" *ngIf="previewOptions.length; else libraryPreviewEmptyTpl">
            <label class="pv2-preview-card-inline__option" *ngFor="let option of previewOptions">
              <input [type]="selectedLibraryGroup?.type === 'single' ? 'radio' : 'checkbox'" disabled tabindex="-1" aria-hidden="true">
              <span>{{ option }}</span>
            </label>
          </div>
          <ng-template #libraryPreviewEmptyTpl>
            <div class="pv2-preview-card-inline__empty">Selecione um item da biblioteca para visualizar as opções.</div>
          </ng-template>

          <footer class="pv2-preview-card-inline__footer">
            <span class="fa fa-eye"></span>
            Visão do cliente
          </footer>
          <button type="button" class="pv2-preview-duplicate-btn"
                  *ngIf="selectedLibraryGroup"
                  [disabled]="libraryLinking"
                  (click)="duplicateFocusedLibraryGroup()">
            <span class="fa fa-clone"></span>
            Duplicar para este produto
          </button>
        </article>

        <article class="pv2-preview-tip-card">
          <div class="pv2-preview-tip-card__title">
            <span class="fa fa-info-circle"></span>
            {{ previewHintTitle }}
          </div>
          <p>{{ previewHintText }}</p>
        </article>
      </aside>
    </div>

    <footer class="pv2-library-batch-footer">
      <div class="pv2-library-batch-footer__summary" aria-live="polite">
        <strong>{{ selectedLibraryCount }}</strong>
        <span>{{ selectedLibraryCount === 1 ? 'adicional selecionado' : 'adicionais selecionados' }}</span>
      </div>
      <div class="pv2-library-batch-footer__actions">
        <button type="button" class="pv2-ghost-btn" (click)="goBack()" [disabled]="libraryLinking">Cancelar</button>
        <button type="button" class="pv2-primary-btn"
                [disabled]="!selectedLibraryCount || libraryLinking"
                (click)="linkSelectedLibraryGroups()">
          <span class="fa" [ngClass]="libraryLinking ? 'fa-spinner fa-spin' : 'fa-link'"></span>
          {{ libraryLinking ? 'Vinculando...' : 'Vincular ao produto' }}
        </button>
      </div>
    </footer>
  </section>

  <kendo-dialog [title]="deleteDialogTitle" *ngIf="showDeleteDialog" [minWidth]="320" [width]="420" (close)="cancelDelete()">
    <p>{{ deleteDialogBody }}</p>
    <kendo-dialog-actions>
      <button type="button" class="pv2-ghost-btn" (click)="cancelDelete()">Cancelar</button>
      <button type="button" class="pv2-primary-btn pv2-danger-btn" (click)="confirmDelete()">{{ deleteActionLabel }}</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <div class="pv2-adicional-editor__overlay-host">
    <div class="pv2-overlay pv2-overlay--sheet" *ngIf="editSheetOpen" (click)="closeEditSheet()"></div>
    <section class="pv2-edit-sheet" *ngIf="editSheetOpen"
             role="dialog" aria-modal="true" aria-labelledby="pv2-edit-sheet-title">
      <div class="pv2-edit-sheet__handle"></div>
      <header class="pv2-edit-sheet__header">
        <h3 id="pv2-edit-sheet-title">Editar opção</h3>
        <button type="button" class="pv2-icon-btn" (click)="closeEditSheet()">
          <span class="fa fa-times"></span>
        </button>
      </header>
      <nav class="pv2-edit-sheet__tabs" *ngIf="temModuloTabelaPrecos && editingOptionTargetId">
        <button type="button"
                [class.is-active]="editSheetActiveTab === 'dados'"
                (click)="editSheetActiveTab = 'dados'">
          Dados básicos
        </button>
        <button type="button"
                [class.is-active]="editSheetActiveTab === 'tabela-precos'"
                (click)="editSheetActiveTab = 'tabela-precos'">
          Tabela preços
        </button>
      </nav>
      <div class="pv2-edit-sheet__body">
        <ng-container *ngIf="editSheetActiveTab === 'dados'">
          <div class="pv2-edit-sheet__toggle-row pv2-edit-sheet__availability" [class.is-paused]="!editingOptionActive">
            <span><span class="fa" [ngClass]="editingOptionActive ? 'fa-check-circle' : 'fa-pause-circle'" aria-hidden="true"></span>
              {{ editingOptionActive ? 'Opção ativa' : 'Opção pausada' }}</span>
            <label class="pv2-switch">
              <input type="checkbox" role="switch" aria-label="Opção ativa"
                     [(ngModel)]="editingOptionActive" [disabled]="!podeEditarDisponibilidade">
              <span class="pv2-switch-slider"></span>
            </label>
          </div>
          <p class="pv2-field-hint" *ngIf="!podeEditarDisponibilidade">A disponibilidade é controlada pelo catálogo da rede.</p>
          <label class="pv2-edit-sheet__field">
            <span>Nome</span>
            <input #editingOptionNameInput [(ngModel)]="editingOptionName" placeholder="Nome da opção"
                   (keydown.enter)="saveAndCloseEditSheet()" (keydown.escape)="closeEditSheet()">
          </label>
          <label class="pv2-edit-sheet__field">
            <span>Descrição</span>
            <textarea [(ngModel)]="editingOptionDescription" rows="2"
                      placeholder="Explique o que o cliente recebe (opcional)"
                      (keydown.escape)="closeEditSheet()"></textarea>
            <small class="pv2-edit-sheet__field-hint">
              Aparece abaixo do nome da opção quando o cliente escolhe os adicionais.
            </small>
          </label>

          <div class="pv2-edit-sheet__row">
            <label class="pv2-edit-sheet__field pv2-edit-sheet__field--kendo">
              <span>Preço (R$)</span>
              <kendo-numerictextbox [(ngModel)]="editingOptionPrice"
                                    [min]="0" [spinners]="false" [format]="'n2'"
                                    placeholder="0,00">
              </kendo-numerictextbox>
            </label>
            <label class="pv2-edit-sheet__field">
              <span>Código PDV</span>
              <input [(ngModel)]="editingOptionPdv" placeholder="Código PDV"
                     (keydown.enter)="saveAndCloseEditSheet()" (keydown.escape)="closeEditSheet()">
            </label>
          </div>

          <button type="button" class="pv2-edit-sheet__advanced-toggle"
                  [class.is-open]="editSheetAdvancedOpen"
                  (click)="editSheetAdvancedOpen = !editSheetAdvancedOpen">
            <span class="fa fa-sliders"></span>
            Opções avançadas
            <span class="pv2-edit-sheet__advanced-badge"
                  *ngIf="!editSheetAdvancedOpen && hasAdvancedOptionData()">
              <span class="fa fa-circle"></span>
            </span>
            <span class="fa fa-chevron-down pv2-edit-sheet__advanced-chevron"></span>
          </button>

          <div class="pv2-edit-sheet__advanced-body" *ngIf="editSheetAdvancedOpen">
            <label class="pv2-edit-sheet__field pv2-edit-sheet__field--kendo pv2-edit-sheet__field--narrow">
              <span>Qtde. máxima por opção</span>
              <kendo-numerictextbox [(ngModel)]="editingOptionQtdeMaxima"
                                    [min]="0" [spinners]="false" [format]="'n0'"
                                    placeholder="Sem limite">
              </kendo-numerictextbox>
            </label>

            <div class="pv2-edit-sheet__field pv2-edit-sheet__field--image">
              <span>Imagem</span>
              <div class="pv2-option-image-upload">
                <div class="pv2-option-image-upload__preview" *ngIf="editingOptionLinkImagem">
                  <img [src]="resolveOptionImageUrl(editingOptionLinkImagem)" alt="Imagem da opção">
                  <button type="button" class="pv2-option-image-upload__remove" (click)="removeOptionImage()">
                    <span class="fa fa-times"></span>
                  </button>
                </div>
                <label class="pv2-option-image-upload__btn" *ngIf="!editingOptionLinkImagem && !editingOptionUploadingImage">
                  <span class="fa fa-camera"></span>
                  <span>Adicionar imagem</span>
                  <input type="file" accept="image/*" (change)="onOptionImageSelected($event)" hidden>
                </label>
                <div class="pv2-option-image-upload__loading" *ngIf="editingOptionUploadingImage">
                  <span class="fa fa-spinner fa-spin"></span> Enviando...
                </div>
              </div>
            </div>

            <h5 class="pv2-subsection-title">Onde exibir</h5>

            <div class="pv2-edit-sheet__switch-line">
              <div class="pv2-edit-sheet__toggle-row">
                <span>Cardápio de delivery</span>
                <label class="pv2-switch">
                  <input type="checkbox" [(ngModel)]="editingOptionDisponivelParaDelivery"
                         [disabled]="!podeEditarExibicaoOpcoes">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>

              <div class="pv2-edit-sheet__toggle-row">
                <span>Cardápio de mesa</span>
                <label class="pv2-switch">
                  <input type="checkbox" [(ngModel)]="editingOptionDisponivelNaMesa"
                         [disabled]="!podeEditarExibicaoOpcoes">
                  <span class="pv2-switch-slider"></span>
                </label>
              </div>
            </div>

            <p class="pv2-field-hint" *ngIf="!podeEditarExibicaoOpcoes">
              Controlado pelo catálogo da rede.
            </p>
          </div>
        </ng-container>

        <app-produto-tabela-precos
          *ngIf="editSheetActiveTab === 'tabela-precos' && editingOptionTargetId"
          [empresa]="empresa"
          [tipoAlvo]="'OPCAO_ADICIONAL'"
          [alvoId]="editingOptionTargetId"
          [podeEditarPrecos]="podeEditarPrecos">
        </app-produto-tabela-precos>
      </div>
      <footer class="pv2-edit-sheet__footer" *ngIf="editSheetActiveTab === 'dados'">
        <button type="button" class="pv2-edit-sheet__delete" (click)="deleteAndCloseEditSheet()">
          <span class="fa fa-trash"></span>
          <span>Excluir<span class="pv2-edit-sheet__delete-word"> opção</span></span>
        </button>
        <div class="pv2-edit-sheet__btn-row">
          <button type="button" class="pv2-ghost-btn" (click)="closeEditSheet()">Cancelar</button>
          <button type="button" class="pv2-primary-btn" (click)="saveAndCloseEditSheet()" [disabled]="editingOptionUploadingImage">Salvar</button>
        </div>
      </footer>
    </section>

    <div class="pv2-overlay pv2-overlay--sheet" *ngIf="batchSheetOpen" (click)="closeBatchSheet()"></div>
    <section class="pv2-batch-sheet" *ngIf="batchSheetOpen"
             role="dialog" aria-modal="true" aria-labelledby="pv2-batch-sheet-title">
      <div class="pv2-batch-sheet__handle"></div>
      <header class="pv2-batch-sheet__header">
        <div class="pv2-batch-sheet__header-copy">
          <h3 id="pv2-batch-sheet-title">Alterar preço2</h3>
          <span class="pv2-batch-sheet__count">{{ batchSelectedCount }} opções selecionadas</span>
        </div>
        <button type="button" class="pv2-icon-btn pv2-batch-sheet__close" (click)="closeBatchSheet()"
                aria-label="Fechar alterar preço">
          <span class="fa fa-times"></span>
        </button>
      </header>

      <div class="pv2-batch-sheet__content">
        <section class="pv2-batch-sheet__section pv2-batch-sheet__section--selected">
          <span class="pv2-batch-sheet__section-label">Opções selecionadas</span>
          <div class="pv2-batch-sheet__chip-flow">
            <span class="pv2-batch-sheet__chip" *ngFor="let opt of batchSelectedOptions">
              <span class="pv2-batch-sheet__chip-name">{{ opt.name }}</span>
              <em class="pv2-batch-sheet__chip-price">R${{ opt.price | number:'1.2-2':'pt' }}</em>
            </span>
          </div>
        </section>

        <section class="pv2-batch-sheet__section pv2-batch-sheet__section--mode">
          <span class="pv2-batch-sheet__section-label">Modo de ajuste</span>
          <div class="pv2-batch-sheet__mode-cards">
            <button type="button" class="pv2-batch-sheet__mode-card"
                    [class.is-active]="batchAdjustMode === 'increment'"
                    (click)="setBatchAdjustMode('increment')">
              <strong>+/−</strong>
              <span>Soma ou subtrai do preço atual</span>
            </button>
            <button type="button" class="pv2-batch-sheet__mode-card"
                    [class.is-active]="batchAdjustMode === 'fixed'"
                    (click)="setBatchAdjustMode('fixed')">
              <strong>Fixo</strong>
              <span>Define um valor exato para todas</span>
            </button>
            <button type="button" class="pv2-batch-sheet__mode-card"
                    [class.is-active]="batchAdjustMode === 'percent'"
                    (click)="setBatchAdjustMode('percent')">
              <strong>%</strong>
              <span>Reajuste % sobre o preço atual</span>
            </button>
          </div>
        </section>

        <section class="pv2-batch-sheet__section pv2-batch-sheet__section--value">
          <span class="pv2-batch-sheet__section-label">Novo valor</span>
          <label class="pv2-batch-sheet__field">
            <span class="pv2-batch-sheet__field-prefix" *ngIf="batchAdjustMode === 'fixed'">R$</span>
            <span class="pv2-batch-sheet__field-prefix" *ngIf="batchAdjustMode === 'increment'">+/−</span>
            <span class="pv2-batch-sheet__field-prefix" *ngIf="batchAdjustMode === 'percent'">%</span>
            <input [(ngModel)]="batchAdjustValue" type="text" inputmode="decimal" placeholder="0,00">
          </label>
          <span class="pv2-batch-sheet__hint">{{ batchAdjustHint }}</span>
        </section>

        <section class="pv2-batch-sheet__section pv2-batch-sheet__section--preview"
                 *ngIf="batchAdjustValue">
          <span class="pv2-batch-sheet__section-label">Pré-visualização</span>
          <div class="pv2-batch-sheet__preview-row" *ngFor="let opt of batchSelectedOptions">
            <span class="pv2-batch-sheet__preview-name">{{ opt.name }}</span>
            <span class="pv2-batch-sheet__preview-prices">
              <s>R${{ opt.price | number:'1.2-2':'pt' }}</s>
              <span class="fa fa-arrow-right"></span>
              <strong>R${{ batchPreviewPrice(opt) | number:'1.2-2':'pt' }}</strong>
            </span>
          </div>
        </section>
      </div>


      <footer class="pv2-batch-sheet__footer">
        <button type="button" class="pv2-primary-btn pv2-full-btn pv2-batch-sheet__apply"
                (click)="applyBatchAdjust()">
          <span class="fa fa-check"></span>
          Aplicar preço em {{ batchSelectedCount }} opções
        </button>
      </footer>
    </section>
  </div>
</div>
